import { gql, useQuery } from '@apollo/client';
import { CircularProgress } from '@mui/material';
import { accountsAtom } from 'atoms';
import Layout from 'components/Layout';
import React from 'react';
import { useRecoilState } from 'recoil';
import fragments from 'services/fragments';
import { Account } from 'types/Account';
import { useLogout } from 'hooks';

const ACCOUNTS_LIST = gql`
  ${fragments.Accounts}
  query getAccountList($accountTypes: [Int]) {
    Accounts(accountTypes: $accountTypes) {
      ...AccountProperties
    }
  }
`;

function LoadAccounts({ children }: { children: JSX.Element }) {
  const [accounts, setAccounts] = useRecoilState(accountsAtom);
  const { handleLogout } = useLogout();

  const { data, error, loading } = useQuery<{ Accounts: Account[] }>(ACCOUNTS_LIST, {
    variables: {
      accountTypes: [1],
    },
    skip: Boolean(accounts),
  });

  React.useEffect(
    function setDataOnAtom() {
      if (data) {
        if (!data.Accounts?.length) {
          handleLogout();
        }
        setAccounts(data.Accounts);
      }
    },
    [data, setAccounts, handleLogout],
  );

  if (error) {
    throw error;
  }

  if (loading) {
    return (
      <Layout.Container>
        <Layout.Content sx={{ alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress />
        </Layout.Content>
      </Layout.Container>
    );
  }

  if (!accounts) {
    return null;
  }

  return children;
}

export default LoadAccounts;
